/* global Modal */
  
if (!customElements.get('return-modal')) {   
    class ReturnModal extends HTMLElement {
        constructor() {
          super();
          this.documentClickHandler = this.handleDocumentClick.bind(this);
          this.close = this.querySelector('.return-close');
          this.checkbox = this.querySelector('#return-agree');
          this.submitBtn = this.querySelector('#return-confirmed');
          document.addEventListener("click", this.documentClickHandler);
          this.addEventListener('click', this.handleCloseClick);
          this.checkbox.addEventListener('change', this.handleCheckBoxClick.bind(this));
        }

        handleDocumentClick(evt){
           if(!evt.target.closest('#returnBtn')) return;
           this.style.display = "block";
        }

        handleCloseClick(evt){
            if(!evt.target.matches('.return-close')) return;
            this.style.display = "none";
        }

        handleCheckBoxClick(evt){
            if(!evt.target.matches('#return-agree')) return;
            if(this.checkbox.checked){
                this.submitBtn.removeAttribute("disabled");
                this.submitBtn.style.pointerEvents = "all";
              }else{
                this.submitBtn.setAttribute("disabled", "disabled");
                this.submitBtn.style.pointerEvents = "none";
            }
        }
      }
  
      customElements.define('return-modal', ReturnModal);
  }